"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Signature = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Coding_1 = require("./RTTI_Coding");
var RTTI_instant_1 = require("../Scalar/RTTI_instant");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_base64Binary_1 = require("../Scalar/RTTI_base64Binary");
exports.RTTI_Signature = t.recursion('ISignature', function () {
    return t.intersection([
        t.type({
            type: t.array(RTTI_Coding_1.RTTI_Coding),
            who: RTTI_Reference_1.RTTI_Reference
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            when: RTTI_instant_1.RTTI_instant,
            _when: RTTI_Element_1.RTTI_Element,
            onBehalfOf: RTTI_Reference_1.RTTI_Reference,
            targetFormat: RTTI_code_1.RTTI_code,
            _targetFormat: RTTI_Element_1.RTTI_Element,
            sigFormat: RTTI_code_1.RTTI_code,
            _sigFormat: RTTI_Element_1.RTTI_Element,
            data: RTTI_base64Binary_1.RTTI_base64Binary,
            _data: RTTI_Element_1.RTTI_Element
        })
    ]);
});
//# sourceMappingURL=RTTI_Signature.js.map